"use strict"; // Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
// import "core-js/fn/array.find"
// ...

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsonApiNormalizer_1 = require("./jsonApiNormalizer");

exports.JSONAPINormalizer = jsonApiNormalizer_1.default;